import { Container, Graphics, GraphicsContext } from "pixi.js";
import { Textures } from "./Textures";
import { ITransform } from "./ITransform";
import { Game } from "./Game";
import { Geom } from "./Geom";

const circleContext = new GraphicsContext()
	.clear()
	.circle(0, 0, 5)
	.fill(0xFFFFFF)
	.stroke({ width: 2, color: 0x0093E4 });

const bulletPool: Bullet[] = [];

export function createPooledBullet(
	parent: Container,
	x: number,
	y: number,
	angle: number,
	size: number,
	isPlayerBullet: boolean = false,
	damage: number = 2,
): Bullet {
	if (bulletPool.length == 0) {
		for (let i = 0; i < 1000; i++) {
			bulletPool.push(new Bullet(parent));
		}
	}
	const bullet = bulletPool.pop() as Bullet;
	bullet.x = x;
	bullet.y = y;
	bullet.angle = angle;
	bullet.size = size;
	bullet.isPlayerBullet = isPlayerBullet;
	bullet.damage = damage;
	bullet.container.visible = true;
	bullet.destroyed = false;
	bullet.duration = 5000;
	return bullet;
}

export class Bullet implements ITransform {
	private readonly graphics: Graphics = new Graphics(circleContext);
	public speed: number = 0.4;
	public destroyed: boolean = true;
	public angle: number = 0;
	public size: number = 1;
	public isPlayerBullet: boolean = false;
	public damage: number = 1;
	public duration = 1000;

	public constructor(parent: Container) {
		parent.addChild(this.container);
		this.container.visible = false;
	}

	public destroy() {
		if (this.destroyed) throw new Error("Already destroyed.");
		this.container.visible = false;
		this.destroyed = true;
		bulletPool.push(this);
	}

	public tick(deltaMS: number, game: Game) {
		if (this.destroyed) return;

		Geom.moveInDirection(this, this.angle, this.speed * deltaMS)
		if (this.isPlayerBullet) {
			for (const enemy of game.enemies) {
				if (Geom.distance(this, enemy) < enemy.size + this.size) {
					enemy.dealDamage(game, this.damage)
					this.destroy();
				}
			}
			return
		}
		if (Geom.distance(this, game.player) < game.player.size + this.size) {
			if (game.player.takeDamage(game, this.damage)) {
				this.destroy();
			}
		}
		this.duration -= deltaMS;
		if (this.duration < 0) this.destroy();
	}

	// region ITransform

	public get container(): Container {
		return this.graphics;
	}

	public get x(): number {
		return this.container.x;
	}

	public set x(value: number) {
		this.container.x = value;
	}

	public get y(): number {
		return this.container.y;
	}

	public set y(value: number) {
		this.container.y = value;
	}

	public get w(): number {
		return this.container.width;
	}

	public get h(): number {
		return this.container.height;
	}

	// endregion
}
